import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { deleteTile, copyTile, updateTile } from './data';
import { useNotification } from '../../../../../shared/Notification/useNotification';
import Undo from '../Undo.jsx';
import { ACTIVE, PLAN } from '../utils/constants';

export const useDeleteTileMutation = ({ tileHeadline, campaignId }) => {
  const { t } = useTranslation('tiles');
  const { showDelete } = useNotification();
  const queryClient = useQueryClient();

  const { mutate: deleteTileMutation } = useMutation(deleteTile, {
    onSuccess: () => {
      showDelete({
        content: t('deleteNotification.content', { tileHeadline }),
        title: t('deleteNotification.title'),
      });

      if (campaignId) {
        queryClient.invalidateQueries(['campaignData', campaignId]);
      } else {
        queryClient.invalidateQueries(['shelfTiles']);
      }
    },
  });

  return { deleteTileMutation };
};

export const useCopyTileMutation = ({ tileHeadline }) => {
  const { t } = useTranslation('tiles');
  const { showSuccess } = useNotification();
  const queryClient = useQueryClient();

  const { mutate: copyTileMutation } = useMutation(copyTile, {
    onSuccess: () => {
      showSuccess({
        content: t('copyNotification.content', { tileHeadline }),
        title: t('copyNotification.title'),
      });

      queryClient.invalidateQueries(['shelfTiles']);
    },
  });

  return { copyTileMutation };
};

export const useUpdateTileMutation = ({ tileHeadline, campaignId }) => {
  const { t } = useTranslation('tiles');
  const { showSuccess } = useNotification();
  const queryClient = useQueryClient();

  const { mutate: updateTileMutation } = useMutation(updateTile, {
    onSuccess: data => {
      const params = JSON.parse(data.config.data);
      const { tile } = params;
      let message;
      let title;

      if ([ACTIVE, PLAN].includes(tile.status)) {
        title = t('unhideNotification.title');
        message = t('unhideNotification.message');
      } else {
        title = t('hideNotification.title');
        message = t('hideNotification.message');
      }

      showSuccess({
        content: function UndoNotification({ handleClose }) {
          return (
            <Undo
              status={tile.status}
              tileHeadline={tileHeadline}
              campaignId={campaignId}
              tileId={data.data.tileId}
              handleClose={handleClose}
              message={message}
              postStatus={tile.postStatus}
            />
          );
        },
        title,
      });

      if (campaignId) {
        queryClient.invalidateQueries(['campaignData', campaignId]);
      } else {
        queryClient.invalidateQueries(['shelfTiles']);
      }
    },
  });

  return { updateTileMutation };
};
